import { PageLink } from '../../../_metronic/layout/core'
import { ROLE } from '../auth'

export const CLIENTS_PAGE_BREADCRUMBS: Array<PageLink> = [
  {
    title: 'Инфо',
    path: '/client/info/__token__',
    isSeparator: false,
    isActive: false,
    roles: [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_OPERATOR, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER],
  },
  {
    title: 'Настройки',
    path: '/client/edit/__token__',
    isSeparator: false,
    isActive: false,
    roles: [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER],
  },
  {
    title: 'Транзакции',
    path: '/client/transactions/__token__',
    isSeparator: false,
    isActive: false,
    roles: [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_OPERATOR, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER],
  },
  {
    // CPAYMENT-1732: роли — ровно те, кому открыт модуль диспутов на бэкенде
    // (DisputeController::MODULE_ROLES + security.yaml). Список «как у Транзакций» здесь не
    // подходит: операторам мерчанта и оператору мэтчинга модуль закрыт, вкладка вела бы в 403.
    title: 'Диспуты',
    path: '/client/disputes/__token__',
    isSeparator: false,
    isActive: false,
    roles: [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER],
  },
]
